<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select v-model="search.mn" style="width: 7.8em" placeholder="请选择站点" clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <i-input
          prefix="ios-search"
          placeholder="输入设备名称查询"
          v-model="search.name"
          style="width: auto;margin-left: 1em"
        />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="电流最小值" prop="faMin">
          <i-input v-model="formValidate.faMin" type="number" placeholder="输入电流最小值"></i-input>
        </FormItem>
        <FormItem label="电流最大值" prop="faMax">
          <i-input v-model="formValidate.faMax" type="number" placeholder="输入电流最大值"></i-input>
        </FormItem>
        <FormItem label="最小值的状态" prop="minStatus">
          <Select v-model="formValidate.minStatus">
            <Option :value="item.key" :key="item.key" v-for="item in warnList">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="中间状态" prop="middleStatus">
          <Select v-model="formValidate.middleStatus">
            <Option :value="item.key" :key="item.key" v-for="item in warnList">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="最大值的状态" prop="maxStatus">
          <Select v-model="formValidate.maxStatus">
            <Option :value="item.key" :key="item.key" v-for="item in warnList">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否启用" prop="enabled">
          <RadioGroup v-model="formValidate.enabled">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <i-input v-model="formValidate.remark" placeholder="输入备注"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "规则介绍",
            key: "remark",
            width: 160,
            align: "center"
          },
          {
            title: "最小值",
            key: "faMin",
            align: "center"
          },
          {
            title: "最大值",
            key: "faMax",
            align: "center"
          },
          {
            title: "低于最小值状态",
            key: "minStatus",
            align: "center"
          },
          {
            title: "正常值状态",
            key: "middleStatus",
            align: "center"
          },
          {
            title: "超过最大值状态",
            key: "maxStatus",
            align: "center"
          },
          {
            title: "是否启用",
            key: "enabled",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("i-switch", {
                  props: {
                    size: "large",
                    value: params.row.enabled,
                    loading: this.table.isSystem_loading
                  },
                  // scopedSlots: {
                  //   open: () => h("span", "禁用"),
                  //   close: () => h("span", "开启")
                  // },
                  on: {
                    "on-change": value => {
                      // 是否启用切换
                      this.table.isSystem_loading = true; // 开启loading
                      this.$api.Warn.postWarnRoleEdit({
                        content: { id: params.row.id, enabled: value }
                      }, ["uuid", "company"])
                        .then(res => {
                          if (res.code == 0) {
                            this.table.isSystem_loading = false;
                            this.$Message.success("切换成功");
                          } else {
                            this.table.isSystem_loading = false;
                            this.$Message.warning(res.message);
                          }
                        })
                        .catch(err => {
                          this.table.isSystem_loading = false;
                        });
                    }
                  }
                })
              ]);
            }
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h(
                "span",
                {},
                timeStamp(params.row.createDate, "yyyy-MM-dd")
              );
            }
          },

          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id, // 最小值
                          faMin: params.row.faMin, // 最小值
                          faMax: params.row.faMax, // 最大值
                          minStatus: params.row.minStatus + "", // 最小值状态
                          middleStatus: params.row.middleStatus + "", // 中等值状态
                          maxStatus: params.row.maxStatus + "", // 最大值状态
                          enabled: params.row.enabled + "", // 是否启用
                          remark: params.row.remark // 备注
                        };
                        //console.log(this.formValidate);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        name: null, // 设备名
        mn: null // 站点编号
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加",
        companyShow: false // 站点工艺图modal显示隐藏
      },
      // 表单数据
      formValidate: {
        faMin: null, // 最小值
        faMax: null, // 最大值
        minStatus: null, // 最小值状态
        middleStatus: null, // 中等值状态
        maxStatus: null, // 最大值状态
        enabled: null, // 是否启用
        remark: null // 备注
      },
      // 验证
      ruleValidate: {
        faMin: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("不能为空"));
              } else if (value > parseInt(this.formValidate.faMax)) {
                return callback(new Error("不能大于最大值"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "blur"
          }
        ],
        faMax: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("不能为空"));
              } else if (value < parseInt(this.formValidate.faMin)) {
                return callback(new Error("不能小于最小值"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        minStatus: [
          {
            required: true,
            message: "请选择",
            trigger: "change"
          }
        ],
        middleStatus: [
          {
            required: true,
            message: "请选择",
            trigger: "change"
          }
        ],
        maxStatus: [
          {
            required: true,
            message: "不能为空",
            trigger: "change"
          }
        ],
        enabled: [
          {
            required: true,
            message: "不能为空",
            trigger: "change"
          }
        ]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      siteList: [], // 站点枚举
      warnList: [] // 规则枚举
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum(); // 设备枚举
    this.getWarnEnum(); // 规则枚举
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        faMin: null, // 最小值
        faMax: null, // 最大值
        minStatus: null, // 最小值状态
        middleStatus: null, // 中等值状态
        maxStatus: null, // 最大值状态
        enabled: null, // 是否启用
        remark: null // 备注
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Warn.getWarnRoleList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Warn.getWarnRoleDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 如果不存在id 说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Warn.postWarnRoleAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Warn.postWarnRoleEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取规则枚举
    getWarnEnum() {
      this.$api.Enum.getWarnEnum(null, ["uuid", "common"]).then(res => {
        if (res.code == 0) {
          this.warnList = res.data.keys;
        } else {
          this.$Notice.warning({
            title: "获取规则枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    }
  }
};
</script>